export function AppPreviewShopIcon({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      className={className}
    >
      <path
        d="M13.6331 6.66667C13.6331 7.55072 13.2819 8.39857 12.6568 9.02369C12.0316 9.64881 11.1838 10 10.2997 10C9.41569 10 8.56784 9.64881 7.94272 9.02369C7.3176 8.39857 6.96641 7.55072 6.96641 6.66667M3.32743 6.16782L2.7441 13.1678C2.61878 14.6716 2.55612 15.4235 2.81032 16.0035C3.03365 16.5131 3.4206 16.9336 3.9099 17.1985C4.46681 17.5 5.2213 17.5 6.73028 17.5H13.8692C15.3782 17.5 16.1327 17.5 16.6896 17.1985C17.1789 16.9336 17.5658 16.5131 17.7892 16.0035C18.0434 15.4235 17.9807 14.6716 17.8554 13.1678L17.2721 6.16782C17.1642 4.87396 17.1103 4.22703 16.8238 3.73738C16.5715 3.3062 16.1958 2.9605 15.7452 2.74487C15.2334 2.5 14.5842 2.5 13.2859 2.5L7.31361 2.5C6.01527 2.5 5.36609 2.5 4.85434 2.74487C4.4037 2.9605 4.02799 3.3062 3.77568 3.73738C3.48916 4.22703 3.43525 4.87396 3.32743 6.16782Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </svg>
  );
}
